<app-ref-list #list [page]="query.page()" />
